import { SVGProps } from 'react';
import { tokens } from '../../core/theme';

type MouseIconProps = SVGProps<SVGSVGElement> & { color?: string };

export const MouseIcon = ({
  width = 24,
  height = 24,
  color = tokens.colors.brand.red.DEFAULT,
  ...props
}: MouseIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 16V16C14.8954 16 14 15.1046 14 14V11.3333C14 10.2288 14.8954 9.33333 16 9.33333V9.33333C17.1046 9.33333 18 10.2288 18 11.3333V14C18 15.1046 17.1046 16 16 16Z"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x={7.66667}
        y={3.33335}
        width={16.6667}
        height={25.3333}
        rx={6.24999}
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 9.33335V4.00001"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
